import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import i18n from '@gik/i18n';
import { translationKeys } from '@gik/create/i18n/en';
import {
  DonationsFeatureStep,
  ICreateFeaturesDonationsFormValues,
} from '@gik/create/components/FeatureStep/FeatureStep';
import { FormProps, SvgIcon } from '@gik/ui';
import { CreatePageContext } from '@gik/create/components/CreatePage/CreatePage';
import { FeaturesStepInputNames } from '@gik/create/enums/FeaturesStepInputNames';

export interface IDonationsStepProps extends FormProps {
  onSubmit?: (values: ICreateFeaturesDonationsFormValues) => void;
  onChange?: (values: ICreateFeaturesDonationsFormValues) => void;
}

const blockName = 'donations-step';

export default function DonationsStep({ ...otherProps }) {
  const bem = bemBlock(blockName);
  const { donationsFormRef } = React.useContext(CreatePageContext) || { donationsFormRef: null };

  return (
    <DonationsFeatureStep
      ref={donationsFormRef}
      formName={FeaturesStepInputNames.Donations}
      className={bem()}
      icon={<SvgIcon className={bem('icon')} set="gik-icons" name="Fundraising" />}
      title={i18n.t(translationKeys.FundraisingTitle)}
      description={i18n.t(translationKeys.FundraisingCreateStepDescription)}
      finePrint={i18n.t(translationKeys.FundraisingFinePrint)}
      {...otherProps}
    />
  );
}
